module.exports = __webpack_public_path__ + "static/projekt-opakowania-kosmetykow-44af42ffd8b16c5e8ef072440d1b36ab.png";